// extracted by mini-css-extract-plugin
export default {"alert":"styles__alert--fN9u_7ywazbiFaEMm6c5"};